import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="close-toggle"
// Attach to a wrapper containing both the close checkbox and private button
export default class extends Controller {
  static targets = ["close", "private"]

  toggle() {
    if (this.closeTarget.checked) {
      this.privateTarget.disabled = true
      this.privateTarget.classList.add('disabled')
    } else {
      this.privateTarget.disabled = false
      this.privateTarget.classList.remove('disabled')
    }
  }
}
